import type { SetValueConfig } from "react-hook-form";

export const monthCellWriteOptions: SetValueConfig = {
  shouldValidate: true,
  shouldDirty: true,
};
